import type { FeatureFlags } from "../config/features";

export function formatStatusDetail(
  detail: string,
  flags: FeatureFlags,
): string {
  const flagNote =
    flags.experimentalRenderer ? " · experimental renderer ON" : "";
  return `${detail}${flagNote}`;
}
